import script from "./ProfilePasswordResetStepTwoPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfilePasswordResetStepTwoPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProfilePasswordResetStepTwoPage.vue?vue&type=style&index=0&id=48aabd02&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48aabd02"]])

export default __exports__